/**
 * @file
 * Sliders.
 */
(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.tabOverflow = {
    attach: function (context, settings) {

      $(document).ready(function () {

        // when the page loads
        Drupal.autoCollapse('.course-summary__nav .nav.nav-tabs');

        // when the window is resized
        $(window).on('resize', Drupal.debounce(function () {
          Drupal.autoCollapse('.course-summary__nav .nav.nav-tabs');
        }));
      });
    }
  };

})(jQuery, Drupal, drupalSettings);
